var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "", color: "transparent" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _c("v-tab", { attrs: { href: "#0" } }, [
            _vm._v("Conversor Kmz a Csv")
          ]),
          _c("v-tab", { attrs: { href: "#1" } }, [_vm._v("Conversor Director")])
        ],
        1
      ),
      _c("v-divider"),
      _c("Conversor", { attrs: { tabModel: _vm.tabModel } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }